import { render, staticRenderFns } from "./BrandIframe.vue?vue&type=template&id=25951fe8&"
import script from "./BrandIframe.vue?vue&type=script&lang=ts&"
export * from "./BrandIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports